import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import './FloatingButtons.css';

const FloatingButtons = () => {
  // Substitua pelo número de telefone e WhatsApp da loja
  const phoneNumber = '553133602809'; 
  const whatsappMessage = 'Olá! Vim pelo site e gostaria de um orçamento.';

  return (
    <div className="floating-buttons">
      <a href={`tel:${phoneNumber}`} className="float-btn phone-btn" aria-label="Ligar">
        <FaPhoneAlt />
      </a>
      <a 
        href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(whatsappMessage)}`} 
        target="_blank" 
        rel="noopener noreferrer"
        className="float-btn whatsapp-btn"
        aria-label="Chamar no WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}

export default FloatingButtons;